const module = { name: 'movie/overview/headerUI.desktop', exports: {} }; const exports = module.exports;



import { Fandango as Fandango } from 'require-core';



import { Fandango_adobeLaunch as Fandango_adobeLaunch_EventTypes_track } from 'require-global';

const { EventTypes, track } = Fandango_adobeLaunch_EventTypes_track;


import { default as cast } from 'swug-fdRequire-call:movie/shared/desktop/cast';



import { default as heartsUI } from 'swug-fdRequire-call:movie/shared/heartsUI';



import { default as mediaCarouselUI } from 'swug-fdRequire-call:movie/overview/mediaCarouselUI';



import { default as rottenTomatoesRating } from 'swug-fdRequire-call:shared/utils/rottenTomatoesRating';

class MovieInfoLink extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        const shadowTemplate = document.createElement('template');
        shadowTemplate.innerHTML = `
      <style>
        a {
          color: #4691e3; /* secondary_base */
          font-weight: bold;
          -webkit-transition: color .3s linear;
          -moz-transition: color .3s linear;
          -o-transition: color .3s linear;
          transition: color .3s linear;
          text-decoration: none;
          background-color: transparent;
        }

        a:focus,
        a:hover {
          color: #275b93; /* secondary_dark */
          text-decoration: underline;
        }

        .dark__link {
          color: #4691e3;
        }
      </style>
      <a class="movie-detail-header__info-link dark__link" href="#movie-detail-dropdown">Info</a>
      `;
        this.attachShadow({ mode: 'open' })
            .appendChild(shadowTemplate.content.cloneNode(true));
        const dropdown = document.querySelector('#movie-detail-dropdown');
        const watchVideoLink = document.querySelector('watch-videos-link');
        this.addEventListener('click', () => {
            if (dropdown) {
                const elementPosition = dropdown.getBoundingClientRect().top + window.scrollY;
                const offsetPosition = elementPosition - 20;
                window.scrollTo(0, offsetPosition);
            }
            watchVideoLink.focus();
            const { id: movieID, offer, title: movieName, genre: movieGenre, releaseDate, formatSelected, dateSelected } = Fandango.movieDetails;
            track({
                event: EventTypes.PAGE_VIEW,
                pageType: 'mop details',
                pageName: `movie | overview | ${movieName} | details`,
                movieName,
                movieGenre,
                movieID,
                platform: Fandango.context.isMobile ? 'fandango mobile web' : 'fandango web',
                offersWithPurchase: offer && [{
                        offerId: offer.id,
                        offerLabel: offer.label
                    }],
                dateSelected,
                formatSelected,
                releaseDate,
            });
        });
    }
}
window.customElements.define('movie-info-link', MovieInfoLink);
class WatchVideosLink extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        const src = this.getAttribute('src');
        const shadowTemplate = document.createElement('template');
        shadowTemplate.innerHTML = `
      <style>
        a {
          color: #4691e3; /* secondary_base */
          font-weight: bold;
          -webkit-transition: color .3s linear;
          -moz-transition: color .3s linear;
          -o-transition: color .3s linear;
          transition: color .3s linear;
          text-decoration: none;
          background-color: transparent;
        }

        a:focus,
        a:hover {
          color: #275b93; /* secondary_dark */
          text-decoration: underline;
        }

        .dark__link {
          color: #4691e3;
        }
      </style>
      <a class="js-movie-detail-watch-videos dark__link" href="${src}">WATCH VIDEOS</a>
      `;
        this.attachShadow({ mode: 'open' })
            .appendChild(shadowTemplate.content.cloneNode(true));
        this.addEventListener('click', () => {
            track({
                event: EventTypes.WATCH_VIDEOS_CLICKS
            });
        });
    }
}
window.customElements.define('watch-videos-link', WatchVideosLink);


const Selectors = {
    POSTER: '#movie-detail-movie-poster',
}
function onPosterClick() {
    track({
        event: EventTypes.GENERIC_CLICK,
        genericClickDetails: 'mop details false poster click',
    });
}
function attach() {
    rottenTomatoesRating.attach();
    cast.attach();
    heartsUI.attach();
    mediaCarouselUI.attach(Fandango.movieDetails.id);
    document.querySelector(Selectors.POSTER).addEventListener('click', onPosterClick);
}
module.exports = {
    attach
};
export default module.exports;